<div
  class="halves"
  [class.column]="asColumn"
>
  <div class="half">
    @if (loadingStep || step.partialOrder) {
      <motn-spinner></motn-spinner>
    } @else {
      @if (!step.errorAt) {
        @if (enableUseButton) {
          <moti-button-extended
            [styleClasses]="['small', 'green']"
            [isLoading]="selectingStep"
            [popoverHtml]="useInfoHtml"
            [popoverDelay]="popoverInfoDelay"
            (click)="onClickUse()"
          >
            <i class="fa-regular fa-check"></i>
          </moti-button-extended>
        }

        <moti-button-extended-group>
          @if (enableRegenButton && step.config.provider !== Provider.MANUAL) {
            <moti-button-extended
              [styleClasses]="['small', 'dark']"
              [popoverHtml]="regenInfoHtml"
              [popoverDelay]="popoverInfoDelay"
              (click)="onClickRegen()"
            >
                <i class="fa-regular fa-rotate-right fa-rotate-180"></i>
            </moti-button-extended>
          }
        </moti-button-extended-group>
<!--TODO: We will need this later, not at launch-->
<!--        <moti-button-extended-group>-->
<!--          <moti-button-extended-->
<!--            [styleClasses]="['small', 'fuchsia']"-->
<!--            [successTrigger$]="clipboardSuccess$"-->
<!--            (click)="onClickCopy()"-->
<!--          >-->
<!--            <i class="fa-regular fa-clipboard"></i>-->
<!--          </moti-button-extended>-->
<!--        </moti-button-extended-group>-->
      } @else {
        @if (enableRegenButton && step.config.provider !== Provider.MANUAL) {
          <moti-button-extended
            [styleClasses]="['small', 'red']"
            [isLoading]="selectingStep"
            (click)="onClickRegen()"
          >
            Retry <i class="fa-regular fa-rotate-right fa-rotate-180"></i>
          </moti-button-extended>
        }
      }

    }
  </div>

  @if (showModel) {
    <div class="half">
      <moti-alias-label
        [config]="step.config"
      ></moti-alias-label>
    </div>
  }
</div>
